import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const rapidboardLastVisitedProjectRedirectRoute: InvariantRoute = {
	name: 'rapidboard-last-visited-project-redirect',
	path: '/secure/RapidBoard.jspa',
	query: ['projectKey'],
	__unsafeOrder: 1,
};
